import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api.js';

const initialState = {
  rows: [],
  loading: true,
  error: '',
  search: '',
  openCollectors: [],
  openRecords: [],
};

export const fetchAssignmentSummary = createAsyncThunk(
  'assignmentSummary/fetchSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/records/assignments/summary');
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      const message =
        error?.response?.data?.message || 'Failed to fetch assignments summary.';
      return rejectWithValue({ message });
    }
  }
);

const assignmentSummarySlice = createSlice({
  name: 'assignmentSummary',
  initialState,
  reducers: {
    setSearch(state, action) {
      state.search = action.payload;
    },
    toggleCollector(state, action) {
      const key = action.payload;
      state.openCollectors = state.openCollectors.includes(key)
        ? state.openCollectors.filter((k) => k !== key)
        : [...state.openCollectors, key];
    },
    toggleRecord(state, action) {
      const key = String(action.payload || '');
      state.openRecords = state.openRecords.includes(key)
        ? state.openRecords.filter((k) => k !== key)
        : [...state.openRecords, key];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignmentSummary.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchAssignmentSummary.fulfilled, (state, action) => {
        state.rows = action.payload;
        state.loading = false;
        state.error = '';
      })
      .addCase(fetchAssignmentSummary.rejected, (state, action) => {
        state.rows = [];
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch assignments summary.';
      });
  },
});

export const { setSearch, toggleCollector, toggleRecord } =
  assignmentSummarySlice.actions;

export const selectAssignmentSummary = (state) => state.assignmentSummary;

export default assignmentSummarySlice.reducer;
